import { PROJECT_FILES_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { retryMockProjectFile } from './mockProjectFiles';
import { mockDelay, readMockProjectError } from './mockUtils';

export interface RetryProjectFileRequest {
  projectId: string;
  fileId: string;
}

const MOCK_RESPONSE_DELAY_MS = 400;

const retryProjectFileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    retryProjectFile: builder.mutation<void, RetryProjectFileRequest>({
      // The backend has no endpoint to re-run extraction yet: restart it in the mock list (see mockProjectFiles.ts).
      queryFn: async ({ projectId, fileId }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        return retryMockProjectFile(projectId, fileId)
          ? { data: undefined }
          : { error: { status: 404, data: 'File not found' } };
      },
      invalidatesTags: (_result, error, { projectId }) => (error ? [] : [{ type: PROJECT_FILES_TAG, id: projectId }]),
    }),
  }),
});

export const { useRetryProjectFileMutation } = retryProjectFileApi;
